import React from 'react';
import Hero from '../components/Hero';
import Challenges from '../components/Challenges';
import Process from '../components/Process';
import WhyNow from '../components/WhyNow';
import Contact from '../components/Contact';
import Team from '../components/Team';

function Home() {
  return (
    <>
      <Hero />
      <Challenges />
      <Process />
      <WhyNow />
      <Contact />
      <Team />
    </>
  );
}

export default Home;
